/**
 * Route for `kyc-aml-vetting-workflow-fintech-vertical`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { KycAmlVettingWorkflowFintechVerticalPage } from "../features/kyc-aml-vetting-workflow-fintech-vertical/KycAmlVettingWorkflowFintechVerticalPage";

export const kycAmlVettingWorkflowFintechVerticalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/kyc-aml-vetting-workflow-fintech-vertical",
	component: KycAmlVettingWorkflowFintechVerticalPage,
});

export default kycAmlVettingWorkflowFintechVerticalRoute;
